import moment from "moment";
import { BSON } from "realm-web";
import BigNumber from "bignumber.js";
import i18next from "../i18n/i18next";

export function filterSortMapSellsByHourSameDay(sells) {
  const newSells = sells.reduce((prev, s) => {
    const hour = s._id && s._id.hour && Number(s._id.hour);
    if (hour) {
      if (!prev[hour]) {
        prev[hour] = { number: 0, number2: 0 };
      }
      prev[hour].number =
        prev[hour].number + Number(s.total - (s.extraAmount1 || 0));
      prev[hour].number2 = prev[hour].number2 + Number(s.quantity);
    }
    return prev;
  }, {});

  let newSellsList = [];
  for (let hour = 0; hour < 24; hour++) {
    newSellsList.push({
      number: newSells[hour] ? newSells[hour].number : 0,
      number2: newSells[hour] ? newSells[hour].number2 : 0,
      label: hour,
    });
  }

  newSellsList = newSellsList.sort(
    (s1, s2) => Number(s1.label) - Number(s2.label)
  );
  return newSellsList;
}

export function cleanTodaySells(sells) {
  const d = new Date();
  const hour = d.getHours();
  let sliceIndex = null;
  sells.forEach((s, i) => {
    if ((s.label === hour || s.number > 0) && sliceIndex === null) {
      sliceIndex = i;
    }
  });
  return sells.slice(sliceIndex);
}

export function filterSortMapSellsByDay(sells, dateRangeMin, dateRangeMax) {
  const newSells = sells.reduce((prev, s) => {
    const formateMonth =
      s._id.month &&
      (s._id.month.length === 1 ? `0${s._id.month}` : s._id.month);
    const formateDay =
      s._id.dayOfMonth &&
      (s._id.dayOfMonth.length === 1
        ? `0${s._id.dayOfMonth}`
        : s._id.dayOfMonth);
    const date = moment(`${s._id.year}${formateMonth}${formateDay}`);

    if (date.format("YYYYMMDD")) {
      if (!prev[date.format("YYYYMMDD")]) {
        prev[date.format("YYYYMMDD")] = { number: 0, number2: 0 };
      }
      prev[date.format("YYYYMMDD")].number =
        prev[date.format("YYYYMMDD")].number +
        Number(s.total - (s.extraAmount1 || 0));
      prev[date.format("YYYYMMDD")].number2 =
        prev[date.format("YYYYMMDD")].number2 + Number(s.quantity);
    }
    return prev;
  }, {});

  const newSellsList = [];
  for (let day = moment(dateRangeMin); day <= dateRangeMax; day.add(1, "day")) {
    newSellsList.push({
      number: newSells[day.format("YYYYMMDD")]
        ? newSells[day.format("YYYYMMDD")].number
        : 0,
      number2: newSells[day.format("YYYYMMDD")]
        ? newSells[day.format("YYYYMMDD")].number2
        : 0,
      label: day.format("DD/MM"),
    });
  }

  return newSellsList;
}

export function toHexStringIfExists(value) {
  if (typeof value === "string") return value;
  try {
    return value.toHexString();
  } catch (err) {
    console.error("error parsing BSON.Object", err, value);
    throw new Error("invalid objectId");
  }
}

export function filterSortMapSellsByMonth(sells, dateRangeMin, dateRangeMax) {
  const newSells = sells.reduce((prev, s) => {
    const formateMonth =
      s._id.month &&
      (s._id.month.length === 1 ? `0${s._id.month}` : s._id.month);

    const date = moment(`${s._id.year}${formateMonth}`);

    if (date.format("YYYYMMDD")) {
      if (!prev[date.format("YYYYMMDD")]) {
        prev[date.format("YYYYMMDD")] = { number: 0, number2: 0 };
      }
      prev[date.format("YYYYMMDD")].number =
        prev[date.format("YYYYMMDD")].number +
        Number(s.total - (s.extraAmount1 || 0));
      prev[date.format("YYYYMMDD")].number2 =
        prev[date.format("YYYYMMDD")].number2 + Number(s.quantity);
    }
    return prev;
  }, {});

  const newSellsList = [];
  for (
    let month = moment(dateRangeMin);
    month <= dateRangeMax;
    month.add(1, "month")
  ) {
    newSellsList.push({
      number: newSells[month.format("YYYYMMDD")]
        ? newSells[month.format("YYYYMMDD")].number
        : 0,
      number2: newSells[month.format("YYYYMMDD")]
        ? newSells[month.format("YYYYMMDD")].number2
        : 0,
      label: month.format("MM"),
    });
  }

  return newSellsList;
}

export function timeFormat(date) {
  const d = new Date(date);

  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  return d.toLocaleDateString("en-US", options);
}

function toGraphQlValue(value) {
  if (value === null) return undefined;
  if (
    (value && value instanceof BSON.ObjectId) ||
    (value && value instanceof Date) ||
    (value && value instanceof BSON.Decimal128)
  ) {
    // do not touch those types!
    // add any other type
    return value;
  }
  if (value && Array.isArray(value)) {
    return value.map((singleValue) => toGraphQlValue(singleValue));
  }
  if (value && typeof value === "object") {
    // this is an object, analyze
    return toGraphQlObject(value);
  }
  return value;
}

export function toGraphQlObject(data) {
  const result = {};
  Object.keys(data).forEach((key) => {
    result[key] = toGraphQlValue(data[key]);
  });
  return result;
}

export function mapToEntity(array) {
  const result = {};
  array.forEach((item) => (result[item._id] = item));
  return result;
}

export function getDateHeader(start, end) {
  const isToday =
    moment(start).format("YYYYMMDD") === moment(end).format("YYYYMMDD");

  if (isToday) {
    return [` día ${moment(start).format("DD/MM/YYYY")}`];
  }
  return [
    ` periodo ${moment(start).format("DD/MM/YYYY")} a ${moment(end).format(
      "DD/MM/YYYY"
    )}`,
  ];
}

export const disabledDate = (current, minDate, maxDate) => {
  if (!current) {
    return false;
  }
  if (minDate && current < moment(minDate)) {
    return true;
  }
  if (maxDate && current > moment(maxDate)) {
    return true;
  }
  return false;
};

export const disabledTime = (current, minDate, maxDate) => {
  if (!current) {
    return {};
  }

  const disabledHours = [];
  const disabledMinutes = [];

  const currentMoment = moment(current);

  if (minDate) {
    const minMoment = moment(minDate);
    const minHour = minMoment.hour();
    if (currentMoment.isSame(minMoment, "day")) {
      for (let i = 0; i < 24; i++) {
        if (i < minHour) {
          disabledHours.push(i);
        }
      }
      const minMinute = minMoment.minute();
      if (currentMoment.hour() === minHour) {
        for (let i = 0; i < 60; i++) {
          if (i < minMinute) {
            disabledMinutes.push(i);
          }
        }
      }
    }
  }

  if (maxDate) {
    const maxMoment = moment(maxDate);
    const maxHour = maxMoment.hour();
    if (currentMoment.isSame(maxMoment, "day")) {
      for (let i = 0; i < 24; i++) {
        if (i > maxHour) {
          disabledHours.push(i);
        }
      }
      const maxMinute = maxMoment.minute();
      if (currentMoment.hour() === maxHour) {
        for (let i = 0; i < 60; i++) {
          if (i > maxMinute) {
            disabledMinutes.push(i);
          }
        }
      }
    }
  }

  return {
    disabledHours: () => disabledHours,
    disabledMinutes: () => disabledMinutes,
  };
};

export function secondsToTime(seconds, t) {
  if (!t) {
    return "";
  }
  const days = Math.floor(seconds / 86400);
  const remainingSeconds = seconds % 86400;
  const hours = Math.floor(remainingSeconds / 3600);
  const remainingMinutes = remainingSeconds % 3600;
  const minutes = Math.floor(remainingMinutes / 60);

  let formattedTime = "";
  if (days > 0) {
    formattedTime += `${days}d `;
  }
  if (hours > 0) {
    formattedTime += `${hours}h `;
  }
  if (minutes > 0) {
    formattedTime += `${minutes}min `;
  }

  if (seconds < 60) {
    formattedTime = t("general.lessThanAMinute");
  }

  return formattedTime.trim();
}

export const DECIMAL_ZERO = new BigNumber(0);
export const DECIMAL_100 = new BigNumber(100);

export function sortConsolidatedData(data, top, sorter) {
  if (!data) return [];
  return [...data].sort(sorter).slice(0, top);
}

export function calculatePercents(
  data, // : ConsolidatedData[],
  top // : number
) {
  // : ConsolidatedDataWithPercent[]
  const result /* : ConsolidatedDataWithPercent[] */ = [];
  const total = data.reduce(
    (previousValue, currentValue) => previousValue.plus(currentValue.total),
    DECIMAL_ZERO
  );
  data.forEach((consolidatedData, index) => {
    if (index <= top - 1) {
      result.push({
        ...consolidatedData,
        percent: getPercentRatio(total, consolidatedData.total),
      });
    } else {
      result[top - 1] = {
        key: "other",
        name: i18next.t("labels.other", "other", { ns: "reports" }),
        count: result[top - 1].count + consolidatedData.count,
        quantity: result[top - 1].quantity.plus(consolidatedData.quantity),
        total: result[top - 1].total.plus(consolidatedData.count),
        quantity2: result[top - 1].quantity2.plus(consolidatedData.quantity2),
        total2: result[top - 1].total2.plus(consolidatedData.count),
        quantity3: result[top - 1].quantity3.plus(consolidatedData.quantity3),
        total3: result[top - 1].total3.plus(consolidatedData.count),
        percent: result[top - 1].percent.plus(
          getPercentRatio(total, consolidatedData.total)
        ),
      };
    }
  });
  return result;
}

export function getPercentRatio(total, value) {
  return value.multipliedBy(DECIMAL_100).dividedBy(total);
}

/**
 * convert consolidated data to a more friendly format
 * @param consolidated
 * @returns {*}
 */
export function consolidatedToReadable(consolidated) {
  return consolidated.map((consolidatedItem) => ({
    ...consolidatedItem,
    count: consolidatedItem.count && consolidatedItem.count.toNumber(),
    quantity: consolidatedItem.quantity && consolidatedItem.quantity.toNumber(),
    quantity2:
      consolidatedItem.quantity2 && consolidatedItem.quantity2.toNumber(),
    quantity3:
      consolidatedItem.quantity3 && consolidatedItem.quantity3.toNumber(),
    total: consolidatedItem.total && consolidatedItem.total.toNumber(),
    total2: consolidatedItem.total2 && consolidatedItem.total2.toNumber(),
    total3: consolidatedItem.total3 && consolidatedItem.total3.toNumber(),
    percent: consolidatedItem.percent && consolidatedItem.percent.toNumber(),
  }));
}

export function consolidateSummaryWithType(dataArray, keyExtractor, ops) {
  const result = {};
  dataArray.forEach((data) => {
    const key = keyExtractor(data);
    const symbol = data._id.type === "cre" ? -1 : 1;

    const realQuantity = ops?.quantityExtractor
      ? ops.quantityExtractor(data)
      : data.quantity;

    if (!result[key]) {
      result[key] = {
        _id: { ...data._id },
        extraAmount1: data.extraAmount1,
        total: data.total * symbol,
        tax1: data.tax1 * symbol,
        quantity: realQuantity * symbol,
        count: data.count * symbol,
      };
      // delete type from id
      delete result[key]._id.type;
    } else {
      if (ops?.useThisDescription) {
        const res = ops.useThisDescription(data);
        if (res) {
          result[key]._id.itemName = data._id.itemName;
        }
      }
      result[key].total = result[key].total + data.total * symbol;
      result[key].tax1 = result[key].tax1 + data.tax1 * symbol;
      result[key].quantity = result[key].quantity + realQuantity * symbol;
      result[key].count = result[key].count + data.count * symbol;
    }
  });
  return Object.keys(result).map((key) => result[key]);
}
